import { StatusChip } from "../common/StatusChip";

export const getAdministratorColumns = (
  columnHelper,
  handleEdit,
  handleEditPwd
) => [
    columnHelper.accessor("name", {
      header: "Nombre",
      cell: (info) => <strong>{info.getValue()}</strong>,
    }),

    columnHelper.accessor("email", {
      header: "Correo",
      cell: (info) => <span>{info.getValue()}</span>,
    }),

    columnHelper.display({
      id: "estado",
      header: "Estado",
      cell: (props) => {
        const state = props.row.original.state;
        return (
          <StatusChip tone={state ? "success" : "danger"}>
            {state ? "Activo" : "Inactivo"}
          </StatusChip>
        );
      },
    }),

    columnHelper.display({
      id: "role",
      header: "Rol",
      cell: (props) => {
        const role = props.row.original.role;
        const mapping = { ADMIN: "Administrador", ADMIN_ASSISTANT: "Auxiliar Administrativo", ASSISTANT: "Auxiliar" };
        return <StatusChip tone="neutral">{mapping[role] ?? role}</StatusChip>;
      },
    }),

    columnHelper.display({
      id: "acciones",
      header: "Acciones",
      cell: (props) => {
        const admin = props.row.original;

        return (
          <div className="d-flex gap-2 justify-content-end">
            <button
              type="button"
              className="ui-icon-btn"
              onClick={() => handleEdit(admin)}
              title="Editar"
            >
              <i className="ri-edit-line" />
            </button>

            <button
              type="button"
              className="ui-icon-btn"
              onClick={() => handleEditPwd(admin)}
              title="Cambiar contraseña"
            >
              <i className="ri-key-2-line" />
            </button>
          </div>
        );
      },
    }),
  ];
